module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/DailyPrecipitation200/Tokyo_DailyPrecipitation200_MRI_RCP85_End.png";